import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { AreaMultiselectModule } from '../../../areas/components/multiselect';
import { CampanhaStatusModule } from '../status';
import { RepresentanteMultiselectModule } from '../../../pessoa/representante/multiselect';
import { ClienteTypeaheadSharedModule } from '../../../pessoa/cliente/typeahead/cliente-typeahead-shared.module';
import { TipoPromocaoCampanhaModule } from '../../promocao/tipo';
import { PacoteCampanhaMultiselectModule } from '../../pacotes/components/multiselect';

import { CampanhaFilterComponent } from './campanha-filter.component';

@NgModule({
    imports: [
        SharedModule,
        AreaMultiselectModule,
        CampanhaStatusModule,
        RepresentanteMultiselectModule,
        ClienteTypeaheadSharedModule,
        TipoPromocaoCampanhaModule,
        PacoteCampanhaMultiselectModule
    ],
    declarations: [
        CampanhaFilterComponent
    ],
    exports: [
        CampanhaFilterComponent
    ]
})
export class CampanhaFilterModule { }
